import { DeleteFilled, EyeOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Switch } from "antd";

const CateringPackageSelect = ({
  setAddPackageModalOpen,
  packages,
  handleRemovePackage,
  calculatePackageTotal,
  calculateTotal,
  discount,
  setDiscount,
  discountType,
  setDiscountType,
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">Choose packages and quantity</h3>
        <Button
          type="primary"
          onClick={() => setAddPackageModalOpen(true)}
          className="bg-gradient-to-r from-[#D06D01] to-[#F9A022] hover:from-[#F9A022] hover:to-[#D06D01] border-0"
        >
          <PlusOutlined className="my-auto" /> Add Package
        </Button>
      </div>

      {packages.length > 0 ? (
        <div className="border rounded-lg overflow-hidden">
          <div className="grid grid-cols-12 gap-4 p-3 bg-gray-100 text-xs font-medium">
            <div className="col-span-5">PRODUCT</div>
            <div className="col-span-3 text-center">QUANTITY</div>
            <div className="col-span-3 text-center">SUBTOTAL</div>
            <div className="col-span-1"></div>
          </div>

          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className="grid grid-cols-12 gap-4 p-3 border-b items-center"
            >
              <div className="col-span-5 flex items-center gap-2">
                {pkg.packageImageUrl ? (
                  <div className="w-12 h-12">
                    <img src={pkg.packageImageUrl} alt={pkg.packageName} />
                  </div>
                ) : (
                  <div>🍽️</div> // Fallback emoji
                )}
                <div>
                  <div className="text-sm font-medium">{pkg.packageName}</div>
                </div>
              </div>
              <div className="col-span-3 text-center text-sm">
                {pkg.totalPeople} servings
              </div>
              <div className="col-span-3 text-center text-sm font-medium">
                ₦{calculatePackageTotal(pkg).toLocaleString()}
              </div>
              <div className="col-span-1 flex gap-2">
                <button className="text-gray-500 hover:text-gray-700">
                  <EyeOutlined />
                </button>
                <button
                  onClick={() => handleRemovePackage(pkg.id)}
                  className="text-red-500 hover:text-red-700"
                >
                  <DeleteFilled />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12 text-gray-500">
          <p>No packages added yet</p>
          <p className="text-sm">Click "Add Package" to get started</p>
        </div>
      )}

      <div className="mt-6 text-right">
        <span className="text-sm text-gray-600">TOTAL AMOUNT: </span>
        <span className="text-lg font-bold">
          ₦{calculateTotal().toLocaleString()}
        </span>
      </div>

      <div className="mt-6 flex items-center gap-3">
        <span className="text-sm font-medium">Discount Type:</span>
        <Switch
          checked={discountType === "percentage"}
          onChange={(checked) =>
            setDiscountType(checked ? "percentage" : "fixed")
          }
          checkedChildren="(%)"
          unCheckedChildren="(₦)"
        />
      </div>

      <div className="mt-6">
        <h4 className="text-sm font-medium mb-2">Apply Discount/Promos</h4>
        <input
          type="text"
          placeholder="input discount value"
          className="w-full p-3 border border-gray-300 rounded text-sm"
          value={discount}
          onChange={(e) => setDiscount(e.target.value)}
        />
      </div>
    </div>
  );
};
export default CateringPackageSelect;
